import React from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

export const ITEMS_PER_PAGE = 10;

// Student-side counterpart to UGTeacherReview/Pagination.js — same flat
// (non-grouped) pagination over an already-filtered list, just under the
// ug- prefix so it matches UGStudentDashboard.css instead of ugtr-.
const Pagination = ({ currentPage, totalCount, onPageChange }) => {
  const totalPages = Math.max(1, Math.ceil(totalCount / ITEMS_PER_PAGE));
  if (totalPages <= 1) return null;
  return (
    <div className="ug-pagination">
      <button
        className="ug-page-btn"
        disabled={currentPage === 1}
        onClick={() => onPageChange(currentPage - 1)}
      >
        <FaChevronLeft /> Prev
      </button>
      <span className="ug-page-info">
        Page {currentPage} of {totalPages}
        <span className="ug-page-total"> ({totalCount} entries)</span>
      </span>
      <button
        className="ug-page-btn"
        disabled={currentPage === totalPages}
        onClick={() => onPageChange(currentPage + 1)}
      >
        Next <FaChevronRight />
      </button>
    </div>
  );
};

export default Pagination;
